import { action, makeObservable, observable, reaction } from 'mobx';
import { soundService } from '../services/baseSoundService/soundService';
import { iframeService } from '../services/iframeService';

class UserSettingsStore {
  isTurboOn = false;

  isMusicOn = true;

  isSoundOn = true;

  isHotKeyEnable = false;

  isShowHotKeys = true;

  zoomRangeOpened = false;

  zoomValue = 1;

  isShowMusicIcon = true;

  isNumpadActive = false;

  isShowSoundIcon = true;

  isShowTurboIcon = true;

  constructor() {
    makeObservable(this, {
      isMusicOn: observable,
      isSoundOn: observable,
      isTurboOn: observable,
      zoomValue: observable,
      isShowHotKeys: observable,
      isHotKeyEnable: observable,
      isNumpadActive: observable,
      zoomRangeOpened: observable,
      isShowMusicIcon: observable,
      isShowSoundIcon: observable,
      isShowTurboIcon: observable,
      setIsMusicOn: action.bound,
      setIsSoundOn: action.bound,
      setZoomValue: action.bound,
      setIsTurboOn: action.bound,
      setIsShowHotKeys: action.bound,
      setIsShowTurboIcon: action.bound,
      setZoomRangeOpened: action.bound,
      setIsShowSoundIcon: action.bound,
      changeTurboModeState: action.bound,
      setIsNumpadActive: action.bound,
      setIsShowMusicIcon: action.bound,
      setIsHotKeyEnable: action.bound,
      setIsMusicOnAndIsSoundOn: action.bound,
      localStorageAndUserSettingsInit: action.bound,
    });
    reaction(
      () => [this.isMusicOn, this.isSoundOn],
      (value) => {
        if (value.every((item) => item === true)) {
          iframeService.sendUpdateSettings({
            sounds: true,
          });
        }
        if (value.every((item) => item === false)) {
          iframeService.sendUpdateSettings({
            sounds: false,
          });
        }
      }
    );
    reaction(
      () => this.isTurboOn,
      (value) => {
        iframeService.sendUpdateSettings({
          fastPlay: value,
        });
      }
    );
  }

  setIsShowTurboIcon(bool) {
    this.isShowTurboIcon = bool;
  }

  setIsShowHotKeys(bool) {
    this.isShowHotKeys = bool;
  }

  setZoomRangeOpened() {}

  setZoomValue(value) {
    // if (value < 0.3) {
    //   this.zoomValue = 0.3;
    // } else if (value > 1.7) {
    //   this.zoomValue = 1.7;
    // } else {
    this.zoomValue = value;
    // }
  }

  setIsShowSoundIcon(bool) {
    this.isShowSoundIcon = bool;
  }

  setIsNumpadActive(bool) {
    this.isNumpadActive = bool;
  }

  setIsShowMusicIcon(bool) {
    this.isShowMusicIcon = bool;
  }

  setIsHotKeyEnable(bool) {
    this.isHotKeyEnable = bool;
  }

  updateLocalStorage(updatedSettings) {
    if (localStorage.getItem(this.localStorageKey)) {
      const updatedUserSettings = {
        ...JSON.parse(localStorage.getItem(this.localStorageKey)),
        ...updatedSettings,
      };
      localStorage.setItem(this.localStorageKey, JSON.stringify(updatedUserSettings));
    }
  }

  localStorageAndUserSettingsInit({ gameName: gamePrefix }) {
    this.localStorageKey = gamePrefix;
    const userSettings = JSON.parse(localStorage.getItem(this.localStorageKey));
    const defSettings = {
      isMusicOn: this.isMusicOn,
      isSoundOn: this.isSoundOn,
      isTurboOn: this.isTurboOn,
    };
    if (
      userSettings === null ||
      Object.keys(defSettings).length !== Object.keys(userSettings).length
    ) {
      localStorage.setItem(this.localStorageKey, JSON.stringify(defSettings));
    } else {
      const { isMusicOn, isSoundOn, isTurboOn } = userSettings;

      this.isMusicOn = isMusicOn;
      this.isSoundOn = isSoundOn;
      this.isTurboOn = isTurboOn;
    }
  }

  setIsMusicOn() {
    this.updateLocalStorage({
      isMusicOn: !this.isMusicOn,
    });
    soundService.muteMusic(this.isMusicOn);
    this.isMusicOn = !this.isMusicOn;
  }

  changeTurboModeState() {
    this.updateLocalStorage({
      isTurboOn: !this.isTurboOn,
    });
    this.isTurboOn = !this.isTurboOn;
  }

  setIsTurboOn(value = !this.isTurboOn) {
    this.updateLocalStorage({
      isTurboOn: value,
    });
    this.isTurboOn = value;
  }

  setIsSoundOn() {
    soundService.muteSounds(this.isSoundOn);
    this.updateLocalStorage({
      isSoundOn: !this.isSoundOn,
    });
    this.isSoundOn = !this.isSoundOn;
  }

  setIsMusicOnAndIsSoundOn(isMuteAll) {
    if (isMuteAll) {
      iframeService.sendUpdateSettings({
        sounds: false,
      });
      this.updateLocalStorage({
        isMusicOn: false,
        isSoundOn: false,
      });
      soundService.muteMusic(true);
      soundService.muteSounds(true);
      this.isMusicOn = false;
      this.isSoundOn = false;
    } else {
      iframeService.sendUpdateSettings({
        sounds: true,
      });
      this.updateLocalStorage({
        isMusicOn: true,
        isSoundOn: true,
      });
      soundService.muteMusic(false);
      soundService.muteSounds(false);
      this.isMusicOn = true;
      this.isSoundOn = true;
    }

    this.updateLocalStorage({
      isMusicOn: this.isMusicOn,
      isSoundOn: this.isSoundOn,
    });
  }
}

export const userSettingsStore = new UserSettingsStore();
